import { Space, Button } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type UserGroupSpecsFragment } from '../../../api/fragments/UserGroupSpecs';
import DrawerWithAutoWidth from '../../../components/DrawerWithAutoWidth';
import UserGroupAddDealerForm from './UserGroupAddDealerForm';

export type UserGroupAddDealerDrawerProps = {
    userGroup: UserGroupSpecsFragment;
    onClose: () => void;
    visible: boolean;
};

const UserGroupAddDealerDrawer = ({ userGroup, onClose, visible }: UserGroupAddDealerDrawerProps) => {
    const { t } = useTranslation(['userGroupDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('userGroupDetails:dealerDrawer.cancelButton')}</Button>
                    <Button form="addDealers" htmlType="submit" type="primary">
                        {t('userGroupDetails:dealerDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('userGroupDetails:dealerDrawer.title')}
            visible={visible}
            destroyOnClose
        >
            <UserGroupAddDealerForm onComplete={onClose} userGroup={userGroup} />
        </DrawerWithAutoWidth>
    );
};

export default UserGroupAddDealerDrawer;

export const useAddDealerDrawer = (userGroup: UserGroupAddDealerDrawerProps['userGroup']) => {
    const [visible, setVisible] = useState(false);
    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <UserGroupAddDealerDrawer onClose={actions.close} userGroup={userGroup} visible={visible} />,
    };
};
